import { useLocation } from "react-router-dom";

/** Route paths for subdomain pages — preview (/sites/:slug) vs production build. */
export function useSubdomainPaths(slug) {
  const { pathname } = useLocation();
  const isPreview = pathname.startsWith("/sites/");
  const base = isPreview ? `/sites/${slug}` : "";

  return {
    home: base || "/",
    solutions: `${base}/#solutions`,
    modules: `${base}/#modules`,
    contact: isPreview ? `/sites/${slug}/contact` : "/contact",
  };
}

export function useContactPath(slug) {
  return useSubdomainPaths(slug).contact;
}
